const Pages = Object.freeze({
  Login: "/login",
  Demo: "/demo",
  Logout: "/logout",
  Dashboard: "/dashboard",
  DashboardTeam: "/dashboard/team",
  DashboardOwn: "/dashboard/own",
  DashboardInsights: "/dashboard/insights",
  Reports: "/reports",
  ReportsCompany: "/reports/company",
  ReportsParticipants: "/reports/participants",
  ReportsMeetings: "/reports/meetings",
  ReportsComparisons: "/reports/comparisons",
  ReportsTrends: "/reports/trends",
  ReportsCost: "/reports/cost",
  UsersManagement: "/users-management",
  InsightsSettings: "/insights-settings",
});

export default Pages;
